import { useEffect, useState } from "react";
import useAuthStore from "../../store/useAuthStore";
import { useProfileUpdateStore } from "../../store/useProfileUpdateStore";
import { useUserStore } from "../../store/useUserStore";
import { useRegisterQuestionsStore } from "../../store/useRegisterQuestionsStore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

type LifeStyleProps = {
  onSaveSuccess: () => void;              // ✅ callback to scroll
  
};

const LifeStyle: React.FC<LifeStyleProps> = ({ onSaveSuccess }) => {
  const { activeSection, setActiveSection, updateProfile } = useProfileUpdateStore();
  const { getRegisterQuestions, getQuestionByTitle } = useRegisterQuestionsStore();
  const authStore = useAuthStore.getState();
  const userId = authStore.user.id;
  const user = useUserStore((state) => state.user);
  const getUserDetails = useUserStore((state) => state.getUserDetails);

  // Local state for controlled inputs
  const [selectedAnswers, setSelectedAnswers] = useState<{ [key: string]: string | number }>({});

  const [errors, setErrors] = useState<{ occupation?: string;
      smokes?: string,
      marijuana?: string
      alcohol?: string; 
      workout?: string; 
      pets?: string; 
     
    }>({});

  useEffect(() => {
    getRegisterQuestions();
  }, []);

  // Initialize selectedAnswers from user.user_answers
useEffect(() => {
    if (user?.user_answers?.length > 0) {
      const initialAnswers: { [key: string]: string } = {};
      user.user_answers.forEach((answer: any) => {
        initialAnswers[answer.question_id] = answer.answer_id;
      });
      setSelectedAnswers(initialAnswers);
    }
  }, [user.user_answers]); // Run when user answers are fetched

  useEffect(() => {
    if (!user || user.id !== userId) {
      getUserDetails(userId);
    }
  }, [userId, user, getUserDetails]);

  if (activeSection !== "life_style") return null;

  // Function to validate form before submission
  const validateForm = () => {
    const newErrors: {
        marijuana?: string; 
       
        smokes?: string; 
        alcohol?: string; 
        workout?: string; 
        pets?: string; 
         
} = {
   
};

   

    const smokesQuestion = getQuestionByTitle("Smokes");
    if (smokesQuestion && !selectedAnswers[smokesQuestion.id]) {
      newErrors.smokes = "Smokes status is required.";
    }

    const marijuanaQuestion = getQuestionByTitle("420_firendly");
    if (marijuanaQuestion && !selectedAnswers[marijuanaQuestion.id]) {
      newErrors.marijuana = "Marijuana status is required.";
    }

    const alcoholQuestion = getQuestionByTitle("Drinks");
    if (alcoholQuestion && !selectedAnswers[alcoholQuestion.id]) {
      newErrors.alcohol = "Drinks status is required.";
    }

    const workoutQuestion = getQuestionByTitle("Exercise");
    if (workoutQuestion && !selectedAnswers[workoutQuestion.id]) {
      newErrors.workout = "Exercise is required.";
    }

    const petsQuestion = getQuestionByTitle("Have_pets");
    if (petsQuestion && !selectedAnswers[petsQuestion.id]) {
      newErrors.pets = "Pet is required.";
    }

   

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Function to handle selection of marital status
  const selectOption = (questionId: number, answerId: number) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: answerId, // Store the selected answer for the question
    }));
  };

  // Handle save button click
  const handleSave = async () => {
    if (!validateForm()) return;

    const updatedData = {
     questions: Object.entries(selectedAnswers).map(([question_id, answer_id]) => ({
        question_id,
        answer_id,
      })),
    };

    try {
      await updateProfile(userId, updatedData);
      getUserDetails(userId);
  
      toast.success("Information updated successfully!");
      onSaveSuccess();
       setActiveSection(null); // Uncomment to close
    } catch (error) {
      console.log(error);
      
      toast.error("Failed to update Information. Please try again.");
    }
  };
  const smokesQuestion = getQuestionByTitle("Smokes");
  const smokesQuestionId = smokesQuestion?.id; // Store it once to avoid multiple calls

  const marijuanaQuestion = getQuestionByTitle("420_firendly");
  const marijuanaQuestionId = marijuanaQuestion?.id; // Store it once to avoid multiple calls

  const alcoholQuestion = getQuestionByTitle("Drinks");
  const alcoholQuestionId=alcoholQuestion?.id;

  const workoutQuestion = getQuestionByTitle("Exercise");
  const workoutQuestionId=workoutQuestion?.id;

  const petsQuestion = getQuestionByTitle("Have_pets");
  const petsQuestionId=petsQuestion?.id;



  return (
    <div className="card border mb-3 filter-container">
      <div className="border-bottom pb-4 mb-4 d-flex w-100 align-items-center gap-3">
        <h4 className="mb-0">Lifestyle</h4>
        <button 
          type="button"
          onClick={() => setActiveSection(null)}
          className="btn_close_cross_btn ms-auto"
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      
      <div className="accordion" id="accordionLifestyle">
        {/* Smokes */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className={`accordion-button ${errors.smokes ? '' : ''}`} type="button" data-bs-toggle="collapse"
              data-bs-target="#smokesCollapse" aria-expanded="false"
              aria-controls="smokesCollapse">
              Smokes
            </button>
          </h2>
          <div id="smokesCollapse" className={`accordion-collapse collapse ${errors.smokes ? 'show' : 'show'}`}>
            <div className="accordion-body border-bottom pb-3 mb-3">
              {smokesQuestion?.questions_options.map((option) => {
                const isChecked =
                  smokesQuestionId &&
                  (selectedAnswers[smokesQuestionId] == option.id ||
                   user.user_answers.some(
                     (answer: any) => Number(answer.question_id) === smokesQuestionId && Number(answer.answer_id) === option.id
                   ));
  
                return (
                  <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                    <label className="form-check-label mb-0" htmlFor={`smokes-${option.id}`}>
                      {option.option}
                    </label>
                    <input
                      className="form-check-input ms-2"
                      type="radio"
                      name="smokes"
                      id={`smokes-${option.id}`}
                      defaultChecked={isChecked}
                      onChange={() => selectOption(option.question_id, option.id)}
                    />
                  </div>
                );
              })}
              {errors.smokes && <p className="text-red-500 text-sm">{errors.smokes}</p>}
            </div>
          </div>
        </div>
  
        {/* Marijuana */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className={`accordion-button ${errors.marijuana ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
              data-bs-target="#marijuanaCollapse" aria-expanded="false"
              aria-controls="marijuanaCollapse">
              Marijuana
            </button>
          </h2>
          <div id="marijuanaCollapse" className={`accordion-collapse collapse ${errors.marijuana ? 'show' : ''}`}>
            <div className="accordion-body border-bottom pb-3 mb-3">
              {marijuanaQuestion?.questions_options.map((option) => {
                const isCheckedmarijuana =
                  marijuanaQuestionId &&
                  (selectedAnswers[marijuanaQuestionId] == option.id ||
                   user.user_answers.some(
                     (answer: any) => Number(answer.question_id) == Number(marijuanaQuestionId) && Number(answer.answer_id) == Number(option.id)
                   ));
  
                return (
                  <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                    <label className="form-check-label mb-0" htmlFor={`marijuana-${option.id}`}>
                      {option.option}
                    </label>
                    <input
                      className="form-check-input ms-2"
                      type="radio"
                      name="marijuana"
                      id={`marijuana-${option.id}`}
                      defaultChecked={isCheckedmarijuana}
                      onChange={() => selectOption(option.question_id, option.id)}
                    />
                  </div>
                );
              })}
              {errors.marijuana && <p className="text-red-500 text-sm">{errors.marijuana}</p>}
            </div>
          </div>
        </div>
  
        {/* Alcohol */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className={`accordion-button ${errors.alcohol ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
              data-bs-target="#alcoholCollapse" aria-expanded="false"
              aria-controls="alcoholCollapse">
              Alcohol
            </button>
          </h2>
          <div id="alcoholCollapse" className={`accordion-collapse collapse ${errors.alcohol ? 'show' : ''}`}>
            <div className="accordion-body border-bottom pb-3 mb-3">
              {alcoholQuestion?.questions_options.map((option) => {
                const isCheckedalcohol =
                  alcoholQuestionId &&
                  (selectedAnswers[alcoholQuestionId] == option.id ||
                   user.user_answers.some(
                     (answer: any) => Number(answer.question_id) == alcoholQuestionId && Number(answer.answer_id) == option.id
                   ));
  
                return (
                  <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                    <label className="form-check-label mb-0" htmlFor={`alcohol-${option.id}`}>
                      {option.option}
                    </label>
                    <input
                      className="form-check-input ms-2"
                      type="radio"
                      name="alcohol"
                      id={`alcohol-${option.id}`}
                      defaultChecked={isCheckedalcohol}
                      onChange={() => selectOption(option.question_id, option.id)}
                    />
                  </div>
                );
              })}
              {errors.alcohol && <p className="text-red-500 text-sm">{errors.alcohol}</p>}
            </div>
          </div>
        </div>
  
        {/* Workout */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className={`accordion-button ${errors.workout ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
              data-bs-target="#workoutCollapse" aria-expanded="false"
              aria-controls="workoutCollapse">
              Workout
            </button>
          </h2>
          <div id="workoutCollapse" className={`accordion-collapse collapse ${errors.workout ? 'show' : ''}`}>
            <div className="accordion-body border-bottom pb-3 mb-3">
              {workoutQuestion?.questions_options.map((option) => {
                const isCheckedworkout =
                  workoutQuestionId &&
                  (selectedAnswers[workoutQuestionId] == option.id ||
                   user.user_answers.some(
                     (answer: any) => Number(answer.question_id) === workoutQuestionId && Number(answer.answer_id) === option.id
                   ));
  
                return (
                  <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                    <label className="form-check-label mb-0" htmlFor={`workout-${option.id}`}>
                      {option.option}
                    </label>
                    <input
                      className="form-check-input ms-2"
                      type="radio"
                      name="workout"
                      id={`workout-${option.id}`}
                      defaultChecked={isCheckedworkout}
                      onChange={() => selectOption(option.question_id, option.id)}
                    />
                  </div>
                );
              })}
              {errors.workout && <p className="text-red-500 text-sm">{errors.workout}</p>}
            </div>
          </div>
        </div>
  
        {/* Pets */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className={`accordion-button ${errors.pets ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
              data-bs-target="#petsCollapse" aria-expanded="false"
              aria-controls="petsCollapse">
              Pets
            </button>
          </h2>
          <div id="petsCollapse" className={`accordion-collapse collapse ${errors.pets ? 'show' : ''}`}>
            <div className="accordion-body border-bottom pb-3 mb-3">
              {petsQuestion?.questions_options.map((option) => {
                const isCheckedpets =
                  petsQuestionId &&
                  (selectedAnswers[petsQuestionId] == option.id ||
                   user.user_answers.some(
                     (answer: any) => Number(answer.question_id) === petsQuestionId && Number(answer.answer_id) === option.id
                   ));
  
                return (
                  <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                    <label className="form-check-label mb-0" htmlFor={`pets-${option.id}`}>
                      {option.option}
                    </label>
                    <input
                      className="form-check-input ms-2"
                      type="radio"
                      name="pets"
                      id={`pets-${option.id}`}
                      defaultChecked={isCheckedpets}
                      onChange={() => selectOption(option.question_id, option.id)}
                    />
                  </div>
                );
              })}
              {errors.pets && <p className="text-red-500 text-sm">{errors.pets}</p>}
            </div>
          </div>
        </div>
      </div>
  
      {/* Save Button */}
      <button
        onClick={handleSave}
        className="btn btn-outline-primary w-100 mt-3"
      >
        Save Changes
      </button>
    </div>
  );
};

export default LifeStyle;
